<template>
  <div>
    <slot name="body" :invoice="_invoice" />
  </div>
</template>

<script>
import InvoiceMixin from '@/mixins/invoice'

export default {
  mixins: [InvoiceMixin],
  props: {
    invoice: {
      type: Object,
      required: false
    },
    invoiceId: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      showLoader: true
    }
  },

  computed: {
    _invoice() {
      if (this.invoice) {
        return this.invoice
      } else if (this.invoiceId) {
        return this.$store.getters.getContractByContractNumber(this.invoiceId)
      }
    }
  },

  created() {
    if (this.invoiceId) {
      this.$store.cache.dispatch('fetchContractByContractNumber', this.invoiceId)
        .finally(() => {
          this.showLoader = false
        })
    } else if (this.invoice) {
      this.showLoader = false
    } else {
      console.error("Varken invoice eller invoiceId satt :(")
      this.showLoader = false
    }
  }
}
</script>

